import { create } from 'zustand';

type PreviewUrlKey = `${string}/${string}/${string}`;

type VercelPreviewState = {
  previewUrls: Record<PreviewUrlKey, string | null>;
  setPreviewUrl: (owner: string, repo: string, prNumber: string, url: string | null) => void;
  getPreviewUrl: (owner: string, repo: string, prNumber: string) => string | null;
};

export const useVercelPreviewStore = create<VercelPreviewState>((set, get) => ({
  previewUrls: {},
  /** Stores preview URLs by PR key and skips no-op writes. */
  setPreviewUrl: (owner, repo, prNumber, url) =>
    set((state) => {
      const key = `${owner}/${repo}/${prNumber}` as PreviewUrlKey;
      if ((state.previewUrls[key] ?? null) === url) {
        return state;
      }

      return {
        previewUrls: {
          ...state.previewUrls,
          [key]: url,
        },
      };
    }),
  getPreviewUrl: (owner, repo, prNumber) =>
    get().previewUrls[`${owner}/${repo}/${prNumber}`] ?? null,
}));
